export default class ResizedHeadshot {
  private readonly context: CanvasRenderingContext2D;

  public constructor(private readonly canvas: HTMLCanvasElement) {
    this.context = this.canvas.getContext('2d', {
      willReadFrequently: false,
      desynchronized: true,
      alpha: true
    }) as CanvasRenderingContext2D;

    this.context.imageSmoothingQuality = 'high';
    this.context.imageSmoothingEnabled = true;
  }

  private async loadScreenshot(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const image = new Image();

      image.addEventListener('error', (error) => reject(error));
      image.addEventListener('load', () => resolve(image));

      image.src = url;
    });
  }

  private async getImageFile(): Promise<File> {
    return new Promise((resolve, reject) => {
      this.canvas.toBlob((blob) => {
        if (!blob) return reject('Blob not valid.');
        resolve(new File([blob], 'headshot.png', { type: 'image/png' }));
      });
    });
  }

  public async resize(screenshot: string): Promise<File> {
    this.context.clearRect(0.0, 0.0, this.canvas.width, this.canvas.height);
    const image = await this.loadScreenshot(screenshot);

    this.context.drawImage(
      image,
      0.0,
      0.0,
      this.canvas.width,
      this.canvas.height
    );

    // return this.canvas.toDataURL('image/png', 1.0);
    return this.getImageFile();
  }
}
